module.exports = __webpack_public_path__ + "img/maps.e6084b9b.png";